import React, { useEffect, useState } from "react";
import axios from "axios";
import { toast } from "sonner";
import { useNavigate, useSearchParams } from "react-router-dom";
import { Loader2, Video, Plus } from "lucide-react";
import { Button } from "@/components/ui/button";
import VideoReels from "@/components/VideoReels";
import TrendingHashtagsStrip from "@/components/TrendingHashtagsStrip";
import CreateReelDialog from "@/components/CreateReelDialog";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function Reels() {
  const navigate = useNavigate();
  const [params] = useSearchParams();
  const start = params.get("start");
  const [videos, setVideos] = useState(null);
  const [createOpen, setCreateOpen] = useState(params.get("create") === "1");

  const load = async () => {
    try {
      const r = await axios.get(`${API}/reels`, { params: { limit: 60, start: start || undefined } });
      setVideos(r.data || []);
    } catch { setVideos([]); }
  };
  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => { load(); }, [start]);

  const toggleLike = async (postId) => {
    try {
      const r = await axios.post(`${API}/posts/${postId}/like`);
      setVideos((prev) => prev.map((p) => p.post_id === postId ? { ...p, likes: r.data.likes ?? p.likes } : p));
    } catch (err) { console.warn("[Reels] like failed", err?.message); toast.error("Não foi possível curtir agora"); }
  };
  const addComment = async (postId, text) => {
    const r = await axios.post(`${API}/posts/${postId}/comment`, { content: text });
    setVideos((prev) => prev.map((p) => p.post_id === postId ? { ...p, comments: [...(p.comments || []), r.data] } : p));
  };

  if (videos === null) {
    return <div className="flex items-center justify-center h-[60vh]" data-testid="reels-loading"><Loader2 className="w-6 h-6 animate-spin text-muted-foreground" /></div>;
  }
  if (videos.length === 0) {
    return (
      <div className="max-w-md mx-auto text-center py-16 space-y-4" data-testid="reels-empty">
        <div className="w-16 h-16 mx-auto rounded-2xl bg-primary/10 text-primary flex items-center justify-center"><Video className="w-8 h-8" /></div>
        <h1 className="text-xl font-bold">Ainda não há Reels</h1>
        <p className="text-sm text-muted-foreground">Seja o primeiro a publicar um vídeo curto com música.</p>
        <Button onClick={() => setCreateOpen(true)} className="rounded-full" data-testid="reels-create-first"><Plus className="w-4 h-4 mr-1" /> Criar Reel</Button>
        <CreateReelDialog open={createOpen} onOpenChange={setCreateOpen} onCreated={load} />
      </div>
    );
  }
  return (
    <>
      <VideoReels
        videos={videos}
        startId={start || videos[0]?.post_id}
        onClose={() => navigate("/feed")}
        onLike={toggleLike}
        onComment={addComment}
        initialMuted={false}
      />
      <TrendingHashtagsStrip />
      <button onClick={() => setCreateOpen(true)} data-testid="reels-create-btn" title="Criar Reel"
        className="fixed top-4 left-1/2 -translate-x-1/2 z-[155] h-9 px-4 rounded-full bg-white/15 hover:bg-white/25 backdrop-blur-md text-white text-xs font-semibold flex items-center gap-1.5 transition-colors">
        <Plus className="w-4 h-4" /> Criar Reel
      </button>
      <CreateReelDialog open={createOpen} onOpenChange={setCreateOpen} onCreated={(p) => { setVideos((prev) => [p, ...prev]); }} />
    </>
  );
}
